import { useRemoteConfig } from '@/modules/remote-config'
import { TabRoutes } from '@/navigation/tab-routes'
import { useIsAdmin } from './useUserRoles'

type TabNavConfig = ReturnType<typeof useRemoteConfig.getState>['tab_nav_config']

// New Play / Learn / Read / Profile tab bar, admin only while it's being tested.
// Everyone else keeps the tab bar driven by the tab_nav_config remote config flag.
export const ADMIN_TAB_NAV_CONFIG: TabNavConfig = {
  enabledTabs: {
    homeScreen: false,
    playScreen: true,
    learningScreen: true,
    readScreen: true,
    profileScreen: true,
    membershipScreen: false
  },
  initialRoute: TabRoutes.playScreen
}

export function useTabNavConfig(): { config: TabNavConfig; isAdminTabBar: boolean } {
  const isAdmin = useIsAdmin()
  const remoteConfig = useRemoteConfig((state) => state.tab_nav_config)
  return { config: isAdmin ? ADMIN_TAB_NAV_CONFIG : remoteConfig, isAdminTabBar: isAdmin }
}
